import {
  createApp as _createApp,
  defineComponent,
  h,
  Suspense,
} from 'vue'

export function createApp (component) {
  return _createApp(
    // wrapper w/ Suspense
    // (allows App to be an async. component)
    defineComponent(() => {
      return () => h(Suspense, {}, h(component))
    })
  )
}
